import {useMapMeasurementTypeMutation} from '../../../hooks/mutations/useMapMeasurementTypeMutation'
import {useUnmapMeasurementTypeMutation} from '../../../hooks/mutations/useUnmapMeasurementTypeMutation'

import type {ExtendedLimsMeasurementType} from '@settings/modules/measurements/types/LimsMeasurementType'

interface UseManageMappingRowsProps {
  plantCode: string
  rowsOrderRef: React.MutableRefObject<number[]>
  sortedLimsMeasurementTypes: ExtendedLimsMeasurementType[]
  globalTypeId: number
}

export const useManageMappingRows = ({
  plantCode,
  rowsOrderRef,
  sortedLimsMeasurementTypes,
  globalTypeId
}: UseManageMappingRowsProps) => {
  const {mutate: mapMeasurementType, isPending: isMeasurementTypeBeingMapped} =
    useMapMeasurementTypeMutation()

  const {mutate: unmapMeasurementType, isPending: isMeasurementTypeBeingUnmapped} =
    useUnmapMeasurementTypeMutation()

  const handleSelectLimsType = (
    mappingId: number,
    currentLimsTypeId: number,
    newLimsTypeId: number,
    currentUnitId?: number
  ) => {
    if (currentLimsTypeId === newLimsTypeId) return

    const orderIndex = rowsOrderRef.current.indexOf(currentLimsTypeId)
    if (orderIndex !== -1) {
      rowsOrderRef.current[orderIndex] = newLimsTypeId
    }

    unmapMeasurementType(
      {
        plantCode,
        measurementTypeMappingId: mappingId
      },
      {
        onSuccess: () => {
          mapMeasurementType({
            plantCode,
            globalMeasurementTypeId: globalTypeId,
            limsMeasurementTypeId: newLimsTypeId,
            assignedUnitId: currentUnitId
          })
        }
      }
    )
  }

  const handleSelectLimsUnit = (
    mappingId: number,
    currentLimsTypeId: number,
    unitId: number | undefined
  ) => {
    unmapMeasurementType(
      {
        plantCode,
        measurementTypeMappingId: mappingId
      },
      {
        onSuccess: () => {
          mapMeasurementType({
            plantCode,
            globalMeasurementTypeId: globalTypeId,
            limsMeasurementTypeId: currentLimsTypeId,
            assignedUnitId: unitId
          })
        }
      }
    )
  }

  const handleDeleteMappingRow = (mappingId: number) => {
    const mappingToDelete = sortedLimsMeasurementTypes.find((m) => m.mappingId === mappingId)
    if (mappingToDelete) {
      rowsOrderRef.current = rowsOrderRef.current.filter((id) => id !== mappingToDelete.id)
    }
    unmapMeasurementType({
      plantCode,
      measurementTypeMappingId: mappingId
    })
  }

  return {
    isMeasurementTypeBeingMapped,
    isMeasurementTypeBeingUnmapped,
    handleSelectLimsType,
    handleSelectLimsUnit,
    handleDeleteMappingRow
  }
}
